// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1xF-o","resendInfoText":"OnGoingPaymentBox_resendInfoText__2tDl3"};